import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiPhone, FiMail, FiCalendar, FiStar } from 'react-icons/fi';
import { useModal } from '../services/ModalService';
import './CallToAction.css';

const CallToAction = () => {
  const { openContactModal } = useModal();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="call-to-action">
      <div className="cta-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="container">
        <motion.div 
          className="cta-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div className="cta-badge" variants={itemVariants}>
            <FiStar />
            <span>Ready to Get Started?</span>
          </motion.div>

          <motion.h2 className="cta-title" variants={itemVariants}>
            Scale Your Business with 
            <span className="gradient-text"> Strategic Partnerships</span>
          </motion.h2>

          <motion.p className="cta-subtitle" variants={itemVariants}>
            Join our growing network of successful CPA firms and businesses who have enhanced their capabilities with our specialized services. Let's discuss how we can support your growth objectives.
          </motion.p>

          <motion.div className="cta-actions" variants={itemVariants}>
            <motion.button 
              className="cta-btn primary"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => openContactModal(
                'Strategic Partnership',
                'CTA Section - Get Started Today'
              )}
            >
              <FiArrowRight />
              Get Started Today
            </motion.button>

            <motion.button 
              className="cta-btn secondary"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => openContactModal(
                'Consultation',
                'CTA Section - Schedule Consultation'
              )}
            >
              <FiCalendar />
              Schedule Consultation
            </motion.button>
          </motion.div>

          <motion.div className="contact-options" variants={itemVariants}>
            <div className="contact-item">
              <FiPhone />
              <span>+1 888-735-5515</span>
            </div>
            <div className="contact-item">
              <FiMail />
              <span>support@rkubeinc.com</span>
            </div>
          </motion.div>

          <motion.div className="trust-indicators" variants={itemVariants}>
            <div className="trust-item">
              <div className="trust-icon">
                <FiStar />
              </div>
              <div className="trust-text">
                <strong>99% Client Satisfaction</strong>
                <span>From 25+ Business Partners</span>
              </div>
            </div>
            
            <div className="trust-item">
              <div className="trust-icon">
                <div className="security-badge">SSL</div>
              </div>
              <div className="trust-text">
                <strong>Enterprise Security</strong>
                <span>Industry Leading Encryption</span>
              </div>
            </div>
            
            <div className="trust-item">
              <div className="trust-icon">
                <div className="guarantee-badge">5+</div>
              </div>
              <div className="trust-text">
                <strong>Years Experience</strong>
                <span>Proven Track Record</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction; 